import ApiService from '../api.service'

export type TipoCertificado = 'principal' | 'responsavel'

export interface Certificado {
    id: number
    nome: string
    tipo: TipoCertificado
    exists: boolean
    assinanteNome: string | null
    assinanteDocumento: string | null
    expired?: boolean
    expirationDate?: string
    diasParaExpirar?: number
    subject?: string
    issuer?: string
    error?: string
}

export const certificados = new ApiService<Certificado>('certificados')
